import React from "react";

const EnvironmentBadge = () => {
  const environment = process.env.REACT_APP_NODE_ENV;

  if (environment === "production") return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: "22px",
        backgroundColor: "#2564eb3a",
        color: "#fff",
        zIndex: 999999,
        textAlign: "center",
        lineHeight: "22px",
        fontSize: "11px",
        fontWeight: "bold",
      }}
    >
      You are currently in the{" "}
      {environment.charAt(0).toUpperCase() + environment.slice(1).toLowerCase()}{" "}
      Environment
    </div>
  );
};

export default EnvironmentBadge;
